import { render, staticRenderFns } from "./thirdTrans.vue?vue&type=template&id=6d926ea4&scoped=true"
import script from "./thirdTrans.vue?vue&type=script&lang=js"
export * from "./thirdTrans.vue?vue&type=script&lang=js"
import style0 from "./thirdTrans.vue?vue&type=style&index=0&id=6d926ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d926ea4",
  null
  
)

export default component.exports